import request from 'superagent'
import {getSuggestions} from 'conf'

export default ({viewPort, states, regions, towns}, cb) =>
  request
    .post(getSuggestions())
    .set('Accept', 'application/json')
    .send({viewPort, states, regions, towns})
    .end((err, res) => err ? cb(err) : cb(null, res.body))



/** WEBPACK FOOTER **
 ** ./app/api/suggestions.js
 **/